import Markdown from 'react-markdown';

import { MetricChip } from './MetricChip';

import type { ReactNode } from 'react';

const METRIC_PATTERN = /\[metric:([a-zA-Z_][a-zA-Z0-9_]*)\]/g;

export function parseMetricChips(
  text: string,
  metricLabels?: Record<string, string>,
  onMetricClick?: (metricKey: string) => void,
): ReactNode[] {
  const parts: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(METRIC_PATTERN)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      const segment = text.slice(lastIndex, matchIndex);
      parts.push(
        <Markdown
          key={`md-${matchIndex}`}
          components={{
            p: ({ children }) => <span>{children}</span>,
          }}
        >
          {segment}
        </Markdown>,
      );
    }

    const metricKey = match[1];
    parts.push(
      <MetricChip
        key={`${metricKey}-${matchIndex}`}
        metricKey={metricKey}
        label={metricLabels?.[metricKey]}
        onClick={onMetricClick}
      />,
    );

    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < text.length) {
    const segment = text.slice(lastIndex);
    parts.push(
      <Markdown
        key="md-end"
        components={{
          p: ({ children }) => <span>{children}</span>,
        }}
      >
        {segment}
      </Markdown>,
    );
  }

  return parts;
}

export function extractFirstMetricKey(text: string): string | null {
  const match = METRIC_PATTERN.exec(text);
  METRIC_PATTERN.lastIndex = 0;
  return match ? match[1] : null;
}
